import { bool } from "prop-types";
import { observer } from "mobx-react";
import { Totals, MinAvgMaxKeys } from "@repo/utils";
import { useTranslation } from "react-i18next";
import {
  usePresetFieldNames,
  useEstimateStructure,
  useVisibilityModeCellClassName,
  ResetValueButton, useEstimateEditorSettings,
} from "@tools";
import { TotalContainer } from "../components";
import { useMemo } from "react";

export const TotalTime = observer((containerProps) => {
  const {t} = useTranslation();
  const structure = useEstimateStructure();
  const { allowEdition, isProposal } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  
  const { displayTotalTime, displayTotalTimeMax, displayTotalTwoValues } = structure;
  const { useWeekTime, hasFixedTotalTime, maxValuesAsBuffer } = structure.settings;
  const { hideTotalTime } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideTotalTime);
  
  const presetText = useMemo(() => (
    useWeekTime ? "pt-totalTimeWeeks" : "pt-totalTimeMonths"
  ), [useWeekTime]);
  
  const showMaxValue = useMemo(() => (
    !maxValuesAsBuffer && displayTotalTwoValues && (allowEdition|| displayTotalTime !== displayTotalTimeMax)
  ), [ displayTotalTwoValues, allowEdition, displayTotalTime, displayTotalTimeMax, maxValuesAsBuffer ]);
  
  const handleTimeChange = (time, isMax) => {
    let key = MinAvgMaxKeys.AVG;
    if(isMax)
      key = MinAvgMaxKeys.MAX;
    else if(!maxValuesAsBuffer && showMaxValue)
      key = MinAvgMaxKeys.MIN;
    
    structure.settings.setFixedTotalTime({ [key]: time });
  };
  
  return (
    <TotalContainer
      totalName={ Totals.TIME }
      min={displayTotalTime}
      max={displayTotalTimeMax}
      showMaxValue={showMaxValue}
      onValueChange={handleTimeChange}
      editable
      showDecimals
      textSmaller
      className={className}
      valueClassName={presetText}
      visibilityHidden={hideTotalTime}
      setVisibility={structure.visibility.setHideTotalTime}
      symbolEnd={getFieldName(presetText)}
      applySuffixSpacing
      { ...containerProps }
    >
      {allowEdition && hasFixedTotalTime && (
        <ResetValueButton
          action={() => structure.settings.resetFixedTotalTime()}
          className="text-4xl"
        >
          {t("common.restore_value")}
        </ResetValueButton>
      )}
    </TotalContainer>
  );
})

TotalTime.propTypes = {
  showDivider: bool,
}